<template>
  <div class="">

      <div class="modal fade" id="modal-view-order" data-backdrop="static" focus="true" data-keyboard="false" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title">
                  <!-- {{ itemSku }} Incoming Purchase Orders -->{{ orderEdit.order_number }}
              </h4>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="closeModal"></button>
            </div>
            <div class="modal-body">
                <div class="form-group row ">
                  <div class="col-md-12">
                    <!-- <button class="btn btn-light btn-sm text-white" style="background-color:#ff7a59;" aria-hidden="true" @click="duplicateOrder(orderEdit.id)">Create Duplicate Order</button> -->
                    <!-- <span class="text-muted fst-italic">Note: if you need to edit a completed order please make changes in Shipstation until further notice.</span> -->
                  </div>
              </div>
                <div class="form-group row ">
                  <div class="col-md-6">
                        <label for="rep" class="col-sm-auto col-form-label fw-bold">Sales Rep</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="rep" v-model="orderEdit.user">
                        </div>
                        <!-- upc -->
                        <label for="ssID" class="col-sm-auto col-form-label fw-bold">Shipstation ID</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="ssID" v-model="orderEdit.shipstation_id">
                        </div>

                        <label for="ssStatus" class="col-sm-auto col-form-label fw-bold">Shipstation Status</label>
                      <div class="col-sm-auto">
                        <input type="text" readonly class="form-control-plaintext" id="ssStatus" v-model="orderEdit.shipstation_status">
                      </div>

                      </div>
                      <div class="col-md-6">
                        <label for="closeDate" class="col-sm-auto col-form-label fw-bold">Close Date</label>
                        <div class="col-sm-auto">
                          <input type="text" readonly class="form-control-plaintext" id="closeDate" v-model="closed_date">
                        </div>
                        <!-- upc -->
                        <label for="hubspotID" class="col-sm-auto col-form-label fw-bold">Hubspot Deal</label>
                        <div class="col-sm-auto">
                          <a id="hubspotID" target="_blank" :href="'https://app.hubspot.com/contacts/21619105/deal/' + orderEdit.hubspot_id "class="form-control-plaintext" >{{ orderEdit.hubspot_id }}</a>
                        </div>

                        <label for="hubspotStatus" class="col-sm-auto col-form-label fw-bold">Hubspot Status</label>
                      <div class="col-sm-auto">
                        <input type="text" readonly class="form-control-plaintext" id="hubspotStatus" v-model="orderEdit.hubspot_status">
                      </div>

                      </div>
                    </div>
                    <hr class="my-2">
                    <div class="form-group row">
                        <div class="col-md-6">
                            <label for="contact" class="col-sm-auto col-form-label fw-bold pt-0">Customer</label>
                            <div class="col-sm-auto">
                              <input type="text" readonly class="form-control-plaintext" id="contact" v-model="orderEdit.contact">
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="shipDateOne" class="col-sm-auto col-form-label fw-bold">Ship Date One</label>
                            <div class="col-sm-auto">
                              <input type="text" readonly class="form-control-plaintext" id="shipDateOne" v-model="ship_one_date">
                            </div>
                            <label v-if="orderEdit.ship_two_date" for="shipDateTwo" class="col-sm-auto col-form-label fw-bold">Ship Date Two</label>
                            <div class="col-sm-auto" v-if="orderEdit.ship_two_date">
                              <input type="text" readonly class="form-control-plaintext" id="shipDateTwo" v-model="ship_two_date">
                            </div>
                        </div>
                    </div>
                    <hr class="my-2">
                    <div class="row" v-if="fetched_order_items">
                        <label for="contact" class="col-sm-auto col-form-label fw-bold pt-0">Line Items</label>
                                <div class="line-item-table px-0 mx-0 my-0" >

                                        <div class="line-item-tr" v-for="item in orderEditItems" :key="item.id">
                                            
                                            <div class="line-item-td line-item-img-col">
                                                <div class="position-relative">
                                                    <img class="img-thumbnail" :alt="item.name" :src="item.image_url" crossorigin="anonymous" @error="item.image_url='/imgs/doomswell-placeholder.png'"/>
                                                    <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger">
                                                        {{ item.total_quantity }}
                                                        <!-- <span class="visually-hidden">unread messages</span> -->
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="line-item-td line-item-meta-col pl-2">

                                                            <span class="fw-bold">{{ item.name }}</span>
                                                            &nbsp<span v-if="item.preorder" class="badge bg-success"><small>preorder</small></span>
                                            </div>
                                            <div class="line-item-td line-item-cost-col">
                                                <span class="fw-bold">{{ item.total_cost | currency }}</span>
                                            </div> 
                                        </div>
                                   
                                    </div>
                            </div>

                <!-- <div class="row justify-content-center" v-if="!loading">
                    <div class="col-md-12">
                        <div class="card mb-2" >
                            <div class="card-header">
                                <span class="lead">Order Details</span>
                            </div>
                            <div class="card-body" style="font-size:.9rem;">
                                <div class="row">
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-auto col-form-label fw-bold" for="contactName">Buyer:</label>
                                            <div class="col-sm-auto">
                                                <span id="contactName" class="form-control-plaintext">{{ orderContact.contact_name }}</span>
                                                <span id="company_name" class="form-control-plaintext">{{ orderContact.company_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="email">Email:</label>
                                            <div class="col-sm-9">
                                                <span id="email" class="form-control-plaintext">{{ orderContact.email }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="email">Phone:</label>
                                            <div class="col-sm-9">
                                                <span id="email" class="form-control-plaintext">{{ orderContact.phone }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="orderCity">City:</label>
                                            <div class="col-sm-9">
                                                <span id="orderCity" class="form-control-plaintext">{{ orderContact.city }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-3 col-form-label fw-bold" for="orderState">State:</label>
                                            <div class="col-sm-9">
                                                <span id="orderCity" class="form-control-plaintext">{{ orderContact.state }}</span>
                                                
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="row mb-0">
                                            <label class="col-sm-4 col-form-label fw-bold" for="email">Rep:</label>
                                            <div class="col-sm-8">
                                                <span id="email" class="form-control-plaintext">{{ user.name }}</span>
                                            </div>
                                        </div>
                                        <div class="row mb-0">
                                            <label class="col-sm-4 col-form-label fw-bold" for="email">Order Date:</label>
                                            <div class="col-sm-8">
                                                <span id="email" class="form-control-plaintext">{{ todaysDate }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div> -->




              <!-- {{ orders }} -->
              <!-- <table class="table table-condensed table-hover" style="display:table">
                <thead class="thead-light">
                  <tr>
                    <th scope="col" style="white-space:nowrap;">PO#</th>
                    <th scope="col" style="white-space:nowrap;" class="text-center">Ordered</th>
                    <th scope="col" style="white-space:nowrap;" class="text-center">Received</th>
                    <th scope="col" style="white-space:nowrap;">Arrival Due Date</th>
                  </tr> 
                </thead>
                <tbody>
                  <tr v-for="order in orders">
                    <td>{{ order.po_number }}</td>
                    <td class="text-center">{{ order.quantity_ordered }}</td>
                    <td class="text-center">{{ order.quantity_received }}</td>
                    <td>{{ order.arrival_date | moment }}</td>
                  </tr>
                  <tr>
                    <td><strong>Total</strong></td>
                    <td class="text-center"><strong>{{ totalOrdered }}</strong></td>
                    <td class="text-center"><strong>{{ totalReceived }}</strong></td>
                    <td><span v-if="totalReceived != 0"><strong>Incoming: {{ totalOrdered - totalReceived }}</strong></span></td>
                  </tr>
                </tbody>
              </table>    -->
            </div>
            <!-- Modal Actions -->
            <div class="modal-footer border-none">
              <button type="button" class="btn btn-light" @click="closeModal">
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- end of modal -->
  </div>
</template>

<style lang="css" scoped>
        .line-item-table {
        display: flex;
        flex-flow: column nowrap;
        
        margin: 0.5rem;
        line-height: 2;
        
        flex: 1 1 auto;
        max-width:100%;
        
    }

     .line-item-table > .line-item-tr {
        display: flex;
        flex-wrap: nowrap;
        min-height: 53.5px;
    }

      .line-item-th {
        display: none;
        font-weight: 700;
        background-color: #f2f2f2;
    }

      .line-item-th > .line-item-td {
        white-space: normal;
    }

      .line-item-tr {
        /*min-width: 800px;*/
        display: flex;
        flex-flow: row nowrap;
        border-bottom: 1px solid #d0d0d0;
        padding-top: 10px;
        padding-bottom: 10px;

    }

    .line-item-tr:first-of-type {
        padding-top: 0px;
    }

    .line-item-tr:last-of-type {
        border-bottom: none;
        padding-bottom:  0px;
    }



    .line-item-tr:hover {
        background-color: #f2f2f2;
    }

    .line-item-td {
        display: flex;
        flex-flow: row nowrap;
        flex-grow: 1;
        flex-basis: 0;
        padding: 0.5em;
        word-break: break-word;
        min-width: 0px;
        
        align-items: center;
    }

    

    .line-item-img-col {
        max-width: 75px;
        min-width: 75px;
        justify-content: start;
    }

    .line-item-meta-col {
        font-weight: 500;
        min-width: 207px;
        justify-content: start;
    }

    .line-item-cost-col {
        min-width: 100px;
        justify-content: end;
    }
</style>

<script>
  import moment from 'moment'
  export default {
    props:['order'],
    data() {
      return {
        order_endpoint: "/api/orders/order/",
        orderEdit: [],
        orderEditItems: [],
        errors: [],
        showing_modal: false,
        loading: false,
        fetched_order_items: false,
        closed_date: null,
        ship_one_date: null,
        ship_two_date: null,

      };
    },
    created() {
      // runs when the component is created
      // this.alias();
      Bus.$on('viewOrderModalShow', () => {
        this.orderEdit = this.order;
        // this.getPurchaseOrders();
        this.fetchOrderItems();
        this.showModal();
      });
    },
    mounted() {
      // runs when the element is injected into the browser
    },
    computed: {
      
      // sum: function(items, prop){
      //   return items.reduce( function(a, b){
      //     return a + b[prop];
      //   }, 0);
      // },
      // orderedSum(){
      //   return this.sum(this.orders,'quantity_ordered');
      // },
      
    },
    methods: {
     fetchOrderItems() {
        this.loading = true;
        axios.get(this.order_endpoint + this.orderEdit.id)
        .then((res) => {
            this.orderEditItems = res.data.items;

            // this.products = res.data.data;
            // this.contacts = res.data.contacts;
          }).catch((error) => {
            console.log(error.response.data);
          }).finally(() => {
            this.fetched_order_items = true;
            this.loading = false;
            return true;
          });
      },
      duplicateOrder(order_id){
            // let objIndex = this.orderEdit.items.findIndex((obj => obj.id == item_id));

          let self = this;
          Swal.fire({
            title: 'Are you sure?',
            text: "This will create a new, identical order to the selected order.",
            // icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, copy this order'
          }).then((result) => {
            if (result.value) {
              axios
                .post('/api/orders/duplicate/' + order_id)
                .then((res) => {
                    // console.log('/order/' + res.data.data);
                    window.location.href = '/order/' + res.data.data;
                  // Swal.fire(
                  //   'Copied!',
                  //   'The order has been copied.',
                  //   'success'
                  // );
                }).catch((error) => {
                  console.log(error);
                  // Bus.$emit('newOacAlert', {text: "Could not remove order", type: 'danger'});
                });
            }
          });
        },
      closeModal(){
        $('#modal-view-order').modal('hide');
        Bus.$emit('updateViewPurchaseOrders');
        this.showing_modal = false;
      },
      showModal(){
        $('#modal-view-order').modal('show');
        this.showing_modal = true;
      },
      
    },
    filters: {
        moment: function (date) {
            return moment(date).format('MMMM Do YYYY');
        }
    },
    watch:{
       orderEdit(val) {
           this.closed_date = this.$options.filters.moment(this.orderEdit.closed_at);
           this.ship_one_date = this.$options.filters.moment(this.orderEdit.ship_one_date);
           if(this.orderEdit.ship_two_date)
           {
            this.ship_two_date = this.$options.filters.moment(this.orderEdit.ship_two_date);
           }
           
        },
        // shipOneDate(val) {
            
        // },
    }
  }
  // Bus.$emit('updateUser');
</script>